module.exports = __webpack_public_path__ + "static/media/symbols.a3924861.svg";